import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useToast,
} from '@chakra-ui/react';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { LoanEditRouteParamsStruct } from '../types';
import { useEditLoanContext } from '../useEditLoanContext';
import { colors } from '~/packages/common-frontend/colors';
import { Icon } from '~/packages/common-frontend/components/icons';
import { successToastConfig } from '~/packages/common-frontend/constants';
import { useCancelLoanEditMutation } from '~/packages/loans/requests/loans.gql.generated';

export const ReviewLoanSettingsMenu = () => {
  const params = useParams();
  const { loanId: originalLoanId } = LoanEditRouteParamsStruct.parse(params);

  const toast = useToast();
  const navigate = useNavigate();

  const context = useEditLoanContext();

  const [
    cancelLoanEditApi,
    cancelLoanEditMutation,
  ] = useCancelLoanEditMutation();
  if (cancelLoanEditMutation.error) throw cancelLoanEditMutation.error;

  return (
    <Menu id="review-loan-settings-menu">
      <MenuButton type="button">
        <Icon icon="ellipsis-vertical" />
      </MenuButton>

      <MenuList
        backgroundColor="white"
        borderRadius="8px"
        borderWidth="1px"
        borderColor={colors.gray[100]}
        boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)"
      >
        <MenuItem
          icon={<Icon icon="x" />}
          isDisabled={!context.state || !context.state.newEntities}
          onClick={async () => {
            if (!context.state || !context.state.newEntities) return;

            const { loanAction } = context.state.newEntities;
            await cancelLoanEditApi({
              variables: { loanActionId: loanAction.id },
            });

            toast({
              ...successToastConfig,
              title: 'Successfully canceled edit request',
            });

            navigate(`/loans/${originalLoanId}`);
          }}
        >
          Cancel Request
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
